import { ComponentProps } from 'react'

import styles from './styles.module.scss'
import Text from '../../Text'

interface LabelProps extends ComponentProps<'label'> {
  appearance?: 'error' | 'neutral'
}

const Label = ({ className, appearance, ...props }: LabelProps) => (
  <Text
    as="label"
    weight="medium"
    size="sm"
    {...props}
    color={appearance === 'error' ? 'accent-red-default' : 'element-medium'}
    className={[styles.label, className].join(' ')}
  />
)

export default Label
